module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/ltv_mv_bg-c5a41761ca60f3f09a05f3f99b3082ed.png";